// extracted by mini-css-extract-plugin
export default {"triangle":"Triangle_triangle__Zwqfp"};